import styled from 'styled-components';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const ConfirmationModalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

function DiscardChangesModal({
  isOpen,
  onConfirm,
  onCancel,
}: {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Dialog
      visible={isOpen}
      style={{ width: '450px' }}
      header="Discard changes"
      modal
      footer={
        <>
          <Button label="Cancel" icon="pi pi-times" size="small" text onClick={onCancel} />
          <Button label="Discard" icon="pi pi-check" size="small" severity="warning" onClick={onConfirm} />
        </>
      }
      onHide={onCancel}
    >
      <ConfirmationModalWrapper>
        <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem' }} />
        <span>
          Do you really want to <strong>discard</strong> all your changes?
        </span>
      </ConfirmationModalWrapper>
    </Dialog>
  );
}

export default DiscardChangesModal;
